import './Nav.css.proxy.js';
/* src/components/Nav.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	space,
	text,
	toggle_class
} from "../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let nav;
	let ul;
	let li0;
	let a0;
	let t0;
	let span;
	let t1;
	let t2;
	let t3;
	let li1;
	let t4;
	let a1;
	let li2;
	let t5;
	let t6;
	let a2;
	let li3;
	let t7;
	let t8;
	let a3;
	let li4;
	let t9;
	let t10;
	let a4;
	let li5;
	let t11;
	let t12;
	let a5;
	let li6;
	let t13;

	return {
		c() {
			nav = element("nav");
			ul = element("ul");
			li0 = element("li");
			a0 = element("a");
			t0 = text("clp");
			span = element("span");
			t1 = text(".is");
			t2 = text(" _");
			t3 = space();
			li1 = element("li");
			t4 = space();
			a1 = element("a");
			li2 = element("li");
			t5 = text("home");
			t6 = space();
			a2 = element("a");
			li3 = element("li");
			t7 = text("about");
			t8 = space();
			a3 = element("a");
			li4 = element("li");
			t9 = text("contact");
			t10 = space();
			a4 = element("a");
			li5 = element("li");
			t11 = text("projects");
			t12 = space();
			a5 = element("a");
			li6 = element("li");
			t13 = text("blog");
			this.h();
		},
		l(nodes) {
			nav = claim_element(nodes, "NAV", { class: true });
			var nav_nodes = children(nav);
			ul = claim_element(nav_nodes, "UL", { class: true });
			var ul_nodes = children(ul);
			li0 = claim_element(ul_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			a0 = claim_element(li0_nodes, "A", { href: true, class: true });
			var a0_nodes = children(a0);
			t0 = claim_text(a0_nodes, "clp");
			span = claim_element(a0_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t1 = claim_text(span_nodes, ".is");
			span_nodes.forEach(detach);
			t2 = claim_text(a0_nodes, " _");
			a0_nodes.forEach(detach);
			li0_nodes.forEach(detach);
			t3 = claim_space(ul_nodes);
			li1 = claim_element(ul_nodes, "LI", { class: true });
			children(li1).forEach(detach);
			t4 = claim_space(ul_nodes);
			a1 = claim_element(ul_nodes, "A", { href: true, class: true });
			var a1_nodes = children(a1);
			li2 = claim_element(a1_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			t5 = claim_text(li2_nodes, "home");
			li2_nodes.forEach(detach);
			a1_nodes.forEach(detach);
			t6 = claim_space(ul_nodes);
			a2 = claim_element(ul_nodes, "A", { href: true, class: true });
			var a2_nodes = children(a2);
			li3 = claim_element(a2_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			t7 = claim_text(li3_nodes, "about");
			li3_nodes.forEach(detach);
			a2_nodes.forEach(detach);
			t8 = claim_space(ul_nodes);
			a3 = claim_element(ul_nodes, "A", { href: true, class: true });
			var a3_nodes = children(a3);
			li4 = claim_element(a3_nodes, "LI", { class: true });
			var li4_nodes = children(li4);
			t9 = claim_text(li4_nodes, "contact");
			li4_nodes.forEach(detach);
			a3_nodes.forEach(detach);
			t10 = claim_space(ul_nodes);
			a4 = claim_element(ul_nodes, "A", { href: true, class: true });
			var a4_nodes = children(a4);
			li5 = claim_element(a4_nodes, "LI", { class: true });
			var li5_nodes = children(li5);
			t11 = claim_text(li5_nodes, "projects");
			li5_nodes.forEach(detach);
			a4_nodes.forEach(detach);
			t12 = claim_space(ul_nodes);
			a5 = claim_element(ul_nodes, "A", { href: true, class: true });
			var a5_nodes = children(a5);
			li6 = claim_element(a5_nodes, "LI", { class: true });
			var li6_nodes = children(li6);
			t13 = claim_text(li6_nodes, "blog");
			li6_nodes.forEach(detach);
			a5_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			nav_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "h2 svelte-1pquec8");
			attr(a0, "href", "/");
			attr(a0, "class", "title svelte-1pquec8");
			attr(li0, "class", "svelte-1pquec8");
			attr(li1, "class", "svelte-1pquec8");
			attr(li2, "class", "link left svelte-1pquec8");
			attr(a1, "href", "/");
			attr(a1, "class", "svelte-1pquec8");
			toggle_class(a1, "selected", selected === "/");
			attr(li3, "class", "link left svelte-1pquec8");
			attr(a2, "href", "/about");
			attr(a2, "class", "svelte-1pquec8");
			toggle_class(a2, "selected", selected === "/about");
			attr(li4, "class", "link left svelte-1pquec8");
			attr(a3, "href", "/contact");
			attr(a3, "class", "svelte-1pquec8");
			toggle_class(a3, "selected", selected === "/contact");
			attr(li5, "class", "link left svelte-1pquec8");
			attr(a4, "href", "/projects");
			attr(a4, "class", "svelte-1pquec8");
			toggle_class(a4, "selected", selected === "/projects");
			attr(li6, "class", "link left svelte-1pquec8");
			attr(a5, "href", "https://blog.clp.is/");
			attr(a5, "class", "svelte-1pquec8");
			toggle_class(a5, "selected", selected === "/blog");
			attr(ul, "class", "svelte-1pquec8");
			attr(nav, "class", "svelte-1pquec8");
		},
		m(target, anchor) {
			insert(target, nav, anchor);
			append(nav, ul);
			append(ul, li0);
			append(li0, a0);
			append(a0, t0);
			append(a0, span);
			append(span, t1);
			append(a0, t2);
			append(ul, t3);
			append(ul, li1);
			append(ul, t4);
			append(ul, a1);
			append(a1, li2);
			append(li2, t5);
			append(ul, t6);
			append(ul, a2);
			append(a2, li3);
			append(li3, t7);
			append(ul, t8);
			append(ul, a3);
			append(a3, li4);
			append(li4, t9);
			append(ul, t10);
			append(ul, a4);
			append(a4, li5);
			append(li5, t11);
			append(ul, t12);
			append(ul, a5);
			append(a5, li6);
			append(li6, t13);
		},
		p(ctx, [dirty]) {
			if (dirty & /*selected*/ 0) {
				toggle_class(a1, "selected", selected === "/");
			}

			if (dirty & /*selected*/ 0) {
				toggle_class(a2, "selected", selected === "/about");
			}

			if (dirty & /*selected*/ 0) {
				toggle_class(a3, "selected", selected === "/contact");
			}

			if (dirty & /*selected*/ 0) {
				toggle_class(a4, "selected", selected === "/projects");
			}

			if (dirty & /*selected*/ 0) {
				toggle_class(a5, "selected", selected === "/blog");
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(nav);
		}
	};
}

let selected;

function instance($$self) {
	let links = [
		["home", "/"],
		["about", "/about"],
		["contact", "/contact"],
		["projects", "/projects"],
		["blog", "/blog"]
	];

	return [];
}

class Nav extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Nav;
export { selected };
//# sourceMappingURL=Nav.js.map
